// Company-logo upload shared by the create form and the session screen.
// The master validates the image again on the server; this only gives the
// FDE a fast, readable error and a data URI the preview can render.

export const LOGO_MAX_BYTES = 512 * 1024;
export const LOGO_ACCEPT = 'image/png,image/jpeg,image/webp,image/gif,image/svg+xml';

const LOGO_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg+xml'];

export function readLogoFile(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('Choose a logo image.'));
      return;
    }
    if (!LOGO_TYPES.includes(file.type)) {
      reject(new Error('The logo must be a PNG, JPEG, WebP, GIF, or SVG image.'));
      return;
    }
    if (file.size > LOGO_MAX_BYTES) {
      reject(new Error('The logo must be at most 512 KB.'));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(new Error('The logo file could not be read.'));
    reader.readAsDataURL(file);
  });
}
